import React from 'react';
import { IonCard, IonCardContent, IonIcon } from '@ionic/react';
import { chevronForwardOutline, trashOutline } from 'ionicons/icons';

// Eliminar algo entero (estación, lote, horario): una tarjeta aparte, al
// final, con el ícono en rojo y qué se pierde. Pide confirmación afuera.
const DeleteRow: React.FC<{ title: string; hint: string; disabled?: boolean; onClick: () => void }> = ({
  title,
  hint,
  disabled,
  onClick,
}) => (
  <IonCard className="delete-card">
    <IonCardContent>
      <button className="delete-row" disabled={disabled} onClick={onClick}>
        <span className="delete-icon">
          <IonIcon icon={trashOutline} />
        </span>
        <span className="delete-row-body">
          <span className="delete-row-title">{title}</span>
          <span className="delete-row-hint">{hint}</span>
        </span>
        <IonIcon icon={chevronForwardOutline} className="chevron" />
      </button>
    </IonCardContent>
  </IonCard>
);

export default DeleteRow;
